import {
  HttpEvent,
  HttpHandler,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, finalize, Observable, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { ApiLoaderService } from './api-loader.service';
import { clearSession, getAuthItem } from '../store/auth/auth-session';

@Injectable({
  providedIn: 'root',
})
export class ApiLoaderInterceptorService {

  constructor(
    private loaderService: ApiLoaderService,
    private router: Router
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isPublic = req.headers.get('isPublic') === 'true';
    const hideLoader = req.headers.get('hideLoader') === 'true';
    const existingAccessToken = req.headers.get('x-access-token');
    let token: string | null = null;

    if (typeof window !== 'undefined' && window.localStorage) {
      token = getAuthItem('token');
    }

    // Full-screen loader only for saves (POST/PUT/PATCH/DELETE). Data loads (GET)
    // use the table skeleton / inline spinners so the page doesn't blink on every click.
    const showOverlay = !hideLoader && req.method !== 'GET';
    if (showOverlay) {
      this.loaderService.blockingStarted();
    }

    this.loaderService.requestStarted();

    let modifiedRequest = req;

    // If not public, add Authorization header
    if (!isPublic && token && !existingAccessToken) {
      modifiedRequest = req.clone({
        setHeaders: {
          //   Authorization: `Bearer ${token}`,
          'x-access-token': `${token}`,
          observe: 'response'
        },
      });
    }

    return next.handle(modifiedRequest).pipe(
      catchError((error) => {
        if (error.status === 401) {
          clearSession(); localStorage.clear();
          this.router.navigateByUrl('auth/login');
        }
        return throwError(() => error);
      }),
      // Runs on success, error and cancel, so the count never gets stuck
      finalize(() => {
        this.loaderService.requestEnded();
        if (showOverlay) this.loaderService.blockingEnded();
      })
    );
  }
}
